import React, { useState } from "react";
import axios from "axios";
import "./ForgotPassword.css";
import API_ENDPOINTS from "../../config/config";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const BASE_URL = API_ENDPOINTS.BASE;

  // Configure axios defaults
  axios.defaults.headers.common["Content-Type"] = "application/json";

  const handleRequestReset = async () => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address");
      return;
    }
  
    setError("");
    setLoading(true);
    console.log('Attempting password reset with URL:', API_ENDPOINTS.FORGOT_PASSWORD);
    
    try {
      const response = await axios.post(API_ENDPOINTS.FORGOT_PASSWORD, {
        email,
      });
      console.log('Password reset response:', response);
  
      setMessage("If an account exists with this email, a reset link will be sent.");
      setStep(2);
      setError("");
    } catch (err) {
      console.error('Password reset error:', err);
      console.error('Error response:', err.response);
      setError(
        err.response?.data?.error ||
        "An error occurred while processing your request"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!token) {
      setError("Reset token is required");
      return;
    }
    if (!newPassword || newPassword.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }

    setError("");
    setLoading(true);
    try {
      // const response = await axios.post(`${BASE_URL}/forgot-password.php`, {
      //   token,
      //   newPassword,
      // });
      const response = await axios.post(API_ENDPOINTS.FORGOT_PASSWORD, {
        token,
        newPassword,
      });
  

      if (response.data.success) {
        setStep(3);
        setError("");
      } else {
        setError(response.data.error || "Failed to reset password");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div>
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="forgot-password-input"
            />
            <button
              onClick={handleRequestReset}
              disabled={loading}
              className="forgot-password-button"
            >
              {loading ? "Sending Reset Link..." : "Send Reset Link"}
            </button>
          </div>
        );
      case 2:
        return (
          <div className="step-content">
            {message && <div className="success-message">{message}</div>}
            <p>Please check your email for the reset link.</p>
            <p style={{ fontSize: '0.875rem', color: '#9ca3af', marginTop: '16px' }}>
              The reset link will expire in 1 hour.
            </p>
          </div>
        );
      case 3:
        return (
          <div className="step-content">
            <div className="success-title">
              Password Reset Successfully
            </div>
            <p>You can now log in with your new password.</p>
          </div>
        );
      default:
        return null;
    }
  };

  // This component will be rendered when user clicks the reset link
  const renderResetForm = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const resetToken = urlParams.get("token");

    if (resetToken) {
      // Set the token when component mounts with token in URL
      if (token !== resetToken) {
        setToken(resetToken);
      }
      
      return (
        <div>
          <input
            type="password"
            placeholder="Enter your new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="forgot-password-input"
          />
          <button
            onClick={handleResetPassword}
            disabled={loading}
            className="forgot-password-button"
          >
            {loading ? "Resetting Password..." : "Reset Password"}
          </button>
        </div>
      );
    }

    return renderStep();
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="forgot-password-container">
        <img 
          src="/fantasy.jpeg" 
          alt="Fantasy Packaging Private Limited" 
          className="forgot-password-logo"
        />
        <h2 className="forgot-password-title">Reset Password</h2>
        <p className="forgot-password-subtitle">
          {step === 1 ? "Enter your email to receive a reset link" : 
           step === 2 ? "Check your email for instructions" : 
           "Password reset successful"}
        </p>
        {error && (
          <div className="error-message" role="alert">
            {error}
          </div>
        )}
        {renderResetForm()}
        <a href="/login" className="back-to-login">
          ← Back to Login
        </a>
      </div>
    </div>
  );
};

export default ForgotPassword;
